module.exports = __webpack_public_path__ + "static/img/address_book.fc074db8.svg";